import React, { useEffect, useState } from "react";
// import { documentData } from "../data/QuestionnaireData";
import DataGridComponent from "../commonfields/grid/DataGridComponent";
import { defaultGridConfig } from "../config/DataGridConfig";
import { documentColumns } from "../config/QuestionnaireConfig";
import { useNavigate } from "react-router-dom";
import { CellClickArgs, CellMouseEvent } from "react-data-grid";
import { RoutesEnum, SidebarEnum } from "../tsmodels/RoutesModel";
import "./pages.scss";
import { getSidebarIcon } from "../config/SideBarConfig";
import TextInput from "../commonfields/inputs/TextInput";
import { ReactComponent as SearchIcon } from "../images/search-icon.svg"
import { ReactComponent as UploadIcon } from "../images/upload-icon.svg"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AxiosError } from "axios";
import { catchError } from "../utils/Utils";
import Appservice from "../services/appservice";
import { getDocumentList } from "../helpers/ServiceSections";
import { IDocumentModel } from "../tsmodels/QuestionnaireModel";
import { unescape } from "lodash";
import { ReactComponent as DeleteIcon } from "../images/delete.svg";
import { toast } from "react-toastify";


const DocumentsListPage = () => {
  const navigate = useNavigate();
  const service = new Appservice()

  // states
  const [documentSearch, setDocumentSearch] = useState("");
  const [documentData, setDocumentData] = useState<IDocumentModel[]>([])
  const [loader, setLoader] = useState<boolean>(false)
  const [validationModal,setvalidationModal] = useState<boolean>(false);
  const [selectRow,setSelectRow] = useState<any>({});

  // const
  ///toggle Modal
  const validationToggle = () => setvalidationModal(!validationModal);

      ///Delete Row
      const deleteDocStatus = () => {
        
      const payLoad = {
        status: "Deleted",
        documentId: selectRow.documentId,
      }
          setLoader(true);
          service
            .updateDocStatus(payLoad)
            .then((res: any) => {           
               getDocuments()
            })
            .catch((error: AxiosError) => {
              catchError(error, true);
              setLoader(false);
            }).finally(()=>{
              setSelectRow({})
            })
        
      };

  const deleteDocStatusConfirm = (e:any, row:any) =>{
       e.stopPropagation();
       setSelectRow(row);
       setvalidationModal(true);
  }

  const deleteFunctionality = (row: any, column: any, onRowChange: (row: any) => void) => (
    <div className="table-arrow" onClick = {(e)=>deleteDocStatusConfirm(e,row)}>
    <DeleteIcon/>
  </div>
  )
  
    // document columns for the list
    const columns = documentColumns.map(m=>{
      if(m.columnName=="delete") return {...m,formatter:deleteFunctionality}
      else return m
    });

  // document data for the list
  const data = documentData as any;

  // document data for the list
  const config = { ...defaultGridConfig, sortable: true };

  // funcs - handlers
  const uploadDocument = () => navigate(`/${RoutesEnum.CREATE_NEW}`)

  const handleDocumentSearch = (e: any) => {
    setDocumentSearch(e?.target?.value);
  };

  const onCellClick = (
    args: CellClickArgs<any, unknown>,
    event: CellMouseEvent
  ) => {
    args?.row?.documentId &&
      navigate(`${RoutesEnum.DETAILS}/${args?.row?.documentId}`);
  };
  const onDeleteClick = (
    args: CellClickArgs<any, unknown>,
    event: CellMouseEvent
  ) => {
   // args?.row?.documentId &&
      
  };

  // funcs - render
    // funcs-Api call
   
    const getDocuments = () => {
      const payLoad = getDocumentList;
      setLoader(true);
      service
        .getDocumentList(payLoad)
        .then((res:any) => {
          setDocumentData(res?.data)
     
        })
       
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
  
        .finally(() => {
          setLoader(false);
        });
    };


      // document columns for the list
  
    // funcs - render 
    // useEffect
    useEffect(() => {
      getDocuments();
    }, []);

  return (  
    <> 
    <div className="document-list-page">
      <div className="subheader-container">
        <div className="subheader-left">
          <div className="subheader-icon">
            {getSidebarIcon(SidebarEnum.DOCUMENTS)}
          </div>
          <div className="subheader-title">Document Library</div>
        </div>
        <div className="subheader-right">
          <div className="document-upload">
            <Button onClick={uploadDocument}><UploadIcon className="document-upload-svg" /> Upload Document</Button>
          </div>
          <div className="document-divider"></div>
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={documentSearch}
              onChange={handleDocumentSearch}
              placeholder="Search for a document"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div>
      <div className="document-list-table">
        <DataGridComponent
          gridRows={data}
          gridColumns={columns}
          config={config}
          onCellClick={onCellClick}        
          searchParams={{
            fieldName: ('documentName'),
            value: documentSearch
          }}
        />
      </div>
    </div>
    
      <Modal isOpen={validationModal} toggle={validationToggle}>
      <ModalHeader toggle={validationToggle}>Delete Confirmation</ModalHeader>
      <ModalBody>
      Are you sure you want to delete this {selectRow?.documentName}?
      </ModalBody>
      <ModalFooter>
        <Button
          className="ok-button"
          onClick={() => {
            setvalidationModal(false);
            deleteDocStatus()
          }}
        >
          Ok
        </Button>{" "}
        <Button color="secondary" onClick={() => {setvalidationModal(false);setSelectRow({})}}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
    </>
  );
};

export default DocumentsListPage;
function setLoader(arg0: boolean) {
  throw new Error("Function not implemented.");
}



